"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _Picture = _interopRequireDefault(require("./Picture"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
//
// type scale_container = {
//     w: number,
//     h: number
// }
// logo
// 存在四种情况
// 1. 高度超出/宽度不够。 按照高度比例占满（压缩宽度）
// 2. 宽度超出/高度不够。 按照宽度比例占满（压缩高度）
// 3. 高度超出/宽度超出。 按照前面逻辑进行（即高度>宽度 取高度比例）
// 4. 两者都不超出。     按照默认图片大小局中放置
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var configuration = props.configuration,
    flexTitle = props.flexTitle,
    style = props.style,
    className = props.className,
    description = props.description,
    restProps = __rest(props, ["configuration", "flexTitle", "style", "className", "description"]);
  var compatibleArr = configuration;
  // if (configuration && configuration.length > 3) {
  compatibleArr = configuration && configuration.length % 5 ? __spreadArrays(configuration, new Array(5 - configuration.length % 5).fill({
    supplement: true
  })) : configuration;
  // }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-partner-tiers-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-partner-tiers-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), description ? (/*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-partner-tiers-container-children__article',
    dangerouslySetInnerHTML: {
      __html: description
    }
  })) : '', /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-brand-default-partner-tiers-class', {}),
    ref: ref
  }, restProps), compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.map(function (items, index) {
    var _a = items || {},
      imageSrc = _a.imageSrc,
      title = _a.title,
      supplement = _a.supplement,
      url = _a.url,
      extendProps = _a.extendProps;
    // console.log(reso)
    return url ? (/*#__PURE__*/_react["default"].createElement("a", __assign({
      className: 'flex-brand-default-partner-tiers-class__list-a',
      href: url
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("section", {
      style: configuration.length > 5 && supplement ? {
        visibility: 'hidden'
      } : {},
      key: index,
      className: (0, _classnames["default"])('flex-brand-default-partner-tiers-class__list', {
        'flex-brand-default-partner-tiers-class__list--col3': configuration.length <= 5,
        'flex-brand-default-partner-tiers-class__list--col3--none': supplement && configuration.length <= 5
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-brand-default-partner-tiers-class__list__div'
    }, /*#__PURE__*/_react["default"].createElement(_Picture["default"], {
      index: index,
      imageSrc: imageSrc || 'https://staticintl.cloudcachetci.com/cms/backend-cms/rQmv565_Frame%20117.png'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-brand-default-partner-tiers-class__list__auto-line',
      dangerouslySetInnerHTML: {
        __html: title
      }
    })))) : (/*#__PURE__*/_react["default"].createElement("section", {
      style: configuration.length > 5 && supplement ? {
        visibility: 'hidden'
      } : {},
      key: index,
      className: (0, _classnames["default"])('flex-brand-default-partner-tiers-class__list', {
        'flex-brand-default-partner-tiers-class__list--col3': configuration.length <= 5,
        'flex-brand-default-partner-tiers-class__list--col3--none': supplement && configuration.length <= 5
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-brand-default-partner-tiers-class__list__div', {
        'flex-brand-default-partner-tiers-class__list__div--border': !imageSrc
      })
    }, /*#__PURE__*/_react["default"].createElement(_Picture["default"], {
      index: index,
      imageSrc: imageSrc || 'https://staticintl.cloudcachetci.com/cms/backend-cms/rQmv565_Frame%20117.png'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-brand-default-partner-tiers-class__list__auto-line',
      dangerouslySetInnerHTML: {
        __html: title
      }
    })));
  }))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = exports["default"] = Thumbnail;